// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"80fd815c","239":"7b817395","453":"3033ab8b","732":"2126ee9c"}[chunkId] + ".chunk.js";
};